"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseDuration = exports.FormFieldVideo = exports.FormFieldTextFile = exports.FormFieldTextArea = exports.FormFieldInput = exports.FormFieldImage = exports.FormFieldCheckboxes = exports.FormFieldCheckbox = void 0;
var _react = require("react");
var _material = require("@mui/material");
var _stylex = _interopRequireDefault(require("@stylexjs/stylex"));
var _Style = require("../style/Style");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const FormFieldInput = exports.FormFieldInput = /*#__PURE__*/(0, _react.forwardRef)((props, ref) => {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(FormFieldBase, {
    ...props,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("input", {
      ...props,
      ref: ref,
      type: props.type || 'text',
      value: props.value,
      onChange: props.onChange,
      onKeyDown: event => {
        if (!props.onEnterKey || event.nativeEvent.isComposing || event.key !== 'Enter') return;
        props.onEnterKey();
      },
      ..._stylex.default.props(_Style.formStyle.text)
    })
  });
});
const FormFieldImage = exports.FormFieldImage = /*#__PURE__*/(0, _react.forwardRef)((props, ref) => {
  const imgRef = (0, _react.useRef)(null);
  const [url, setUrl] = (0, _react.useState)('');
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.Grid2, {
    container: true,
    direction: "column",
    spacing: 1,
    ..._stylex.default.props(_Style.wrapper.stretchW),
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      ..._stylex.default.props(_Style.textStyle.p1b),
      children: props.label
    }), url || props.previewUrl ? /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
      ref: imgRef,
      src: url || props.previewUrl,
      alt: props.alt || props.label,
      ..._stylex.default.props(_Style.formStyle.previewImage)
    }) : "画像がアップロードされていません。", /*#__PURE__*/(0, _jsxRuntime.jsx)("input", {
      ...props,
      ref: ref,
      type: 'file',
      accept: 'image/gif, image/png, image/jpeg',
      value: props.value,
      onChange: event => {
        const target = event.target;
        if (!target.files || target.files.length === 0) return;
        const file = target.files[0];
        if (!file) return;
        const reader = new FileReader();
        reader.onload = () => {
          if (!reader || !reader.result) return;
          setUrl(reader.result);
        };
        reader.readAsDataURL(file);
        if (props.onChange) props.onChange(event);
      },
      onKeyDown: event => {
        if (!props.onEnterKey || event.nativeEvent.isComposing || event.key !== 'Enter') return;
        props.onEnterKey();
      },
      ..._stylex.default.props(_Style.formStyle.text, _Style.formStyle.file)
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Grid2, {
      minHeight: 24,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        ..._stylex.default.props(_Style.textStyle.error),
        children: props.errorText
      })
    })]
  });
});
const parseDuration = duration => {
  const minutes = Math.floor(duration / 60);
  const seconds = duration % 60;
  return `${minutes}分${seconds}秒`;
};
exports.parseDuration = parseDuration;
const FormFieldVideo = exports.FormFieldVideo = /*#__PURE__*/(0, _react.forwardRef)((props, ref) => {
  const videoRef = (0, _react.useRef)(null);
  const [url, setUrl] = (0, _react.useState)('');
  const [duration, setDuration] = (0, _react.useState)(0);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.Grid2, {
    container: true,
    direction: "column",
    spacing: 1,
    ..._stylex.default.props(_Style.wrapper.stretchW),
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      ..._stylex.default.props(_Style.textStyle.p1b),
      children: props.label
    }), url || props.previewUrl ? /*#__PURE__*/(0, _jsxRuntime.jsx)("video", {
      controls: true,
      ref: videoRef,
      src: url || props.previewUrl,
      onLoadedMetadata: () => {
        var _videoRef$current;
        if (!videoRef.current) return;
        let duration = ((_videoRef$current = videoRef.current) === null || _videoRef$current === void 0 ? void 0 : _videoRef$current.duration) || 0;
        duration = Math.round(duration);
        setDuration(duration);
        props.onGetDuration && props.onGetDuration(duration);
      },
      ..._stylex.default.props(_Style.formStyle.previewImage)
    }) : "動画がアップロードされていません。", /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      ..._stylex.default.props(_Style.textStyle.p1),
      children: parseDuration(duration)
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("input", {
      ...props,
      ref: ref,
      type: 'file',
      accept: 'video/mp4',
      value: props.value,
      onChange: event => {
        const target = event.target;
        if (!target.files || target.files.length === 0) return;
        const file = target.files[0];
        if (!file) return;
        const reader = new FileReader();
        reader.onload = () => {
          if (!reader || !reader.result) return;
          setUrl(reader.result);
        };
        reader.readAsDataURL(file);
        if (props.onChange) props.onChange(event);
      },
      onKeyDown: event => {
        if (!props.onEnterKey || event.nativeEvent.isComposing || event.key !== 'Enter') return;
        props.onEnterKey();
      },
      ..._stylex.default.props(_Style.formStyle.text, _Style.formStyle.file)
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Grid2, {
      minHeight: 24,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        ..._stylex.default.props(_Style.textStyle.error),
        children: props.errorText
      })
    })]
  });
});
const FormFieldTextArea = exports.FormFieldTextArea = /*#__PURE__*/(0, _react.forwardRef)((props, ref) => {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(FormFieldBase, {
    ...props,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("textarea", {
      ...props,
      ref: ref,
      value: props.value,
      onChange: props.onChange,
      onKeyDown: event => {
        if (!props.onEnterKey || event.nativeEvent.isComposing || event.key !== 'Enter') return;
        props.onEnterKey();
      },
      ..._stylex.default.props(_Style.formStyle.text, _Style.formStyle.textarea)
    })
  });
});
const FormFieldCheckbox = exports.FormFieldCheckbox = /*#__PURE__*/(0, _react.forwardRef)((props, ref) => {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(FormFieldBase, {
    ...props,
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.Grid2, {
      container: true,
      direction: "row",
      alignItems: "center",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("input", {
        ...props,
        ref: ref,
        type: 'checkbox',
        value: props.value,
        checked: props.checked,
        onChange: props.onChange,
        onKeyDown: event => {
          if (!props.onEnterKey || event.nativeEvent.isComposing || event.key !== 'Enter') return;
          props.onEnterKey();
        },
        ..._stylex.default.props(_Style.formStyle.checkbox)
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        children: props.placeholder
      })]
    })
  });
}); // 複数チェックボックスのフォームのコンポーネント
const FormFieldCheckboxes = exports.FormFieldCheckboxes = /*#__PURE__*/(0, _react.forwardRef)((props, ref) => {
  var _props$items;
  console.log("values: " + JSON.stringify(props.values));
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(FormFieldBase, {
    ...props,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Grid2, {
      container: true,
      direction: "column",
      children: (_props$items = props.items) === null || _props$items === void 0 ? void 0 : _props$items.map((item, index) => {
        var _props$values;
        return /*#__PURE__*/(0, _jsxRuntime.jsxs)("label", {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("input", {
            ...props,
            ref: ref,
            type: 'checkbox',
            checked: (_props$values = props.values) === null || _props$values === void 0 ? void 0 : _props$values.includes(item.key),
            onChange: e => {
              props.onChecked && props.onChecked(item.key, e.target.checked);
            },
            ..._stylex.default.props(_Style.formStyle.checkbox)
          }), item.label]
        }, index);
      })
    })
  });
});
const FormFieldBase = props => {
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.Grid2, {
    container: true,
    direction: "column",
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    spacing: 1,
    ..._stylex.default.props(_Style.wrapper.stretchW),
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      ..._stylex.default.props(_Style.textStyle.p1b),
      children: props.label
    }), props.children, props.errorText && /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Grid2, {
      minHeight: 24,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        ..._stylex.default.props(_Style.textStyle.error),
        children: props.errorText
      })
    })]
  });
};
const FormFieldTextFile = exports.FormFieldTextFile = /*#__PURE__*/(0, _react.forwardRef)((props, ref) => {
  const [text, setText] = (0, _react.useState)('');
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.Grid2, {
    container: true,
    direction: "column",
    spacing: 1,
    ..._stylex.default.props(_Style.wrapper.stretchW),
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      ..._stylex.default.props(_Style.textStyle.p1b),
      children: props.label
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("input", {
      ...props,
      ref: ref,
      type: 'file',
      accept: 'text/csv',
      value: props.value,
      onChange: event => {
        const target = event.target;
        if (!target.files || target.files.length === 0) return;
        const file = target.files[0];
        if (!file) return;
        const reader = new FileReader();
        reader.onload = event => {
          var _event$target;
          if (!reader || !reader.result) return;
          props.onChangeValue && props.onChangeValue((_event$target = event.target) === null || _event$target === void 0 ? void 0 : _event$target.result);
        };
        reader.readAsText(file);
      },
      onKeyDown: event => {
        if (!props.onEnterKey || event.nativeEvent.isComposing || event.key !== 'Enter') return;
        props.onEnterKey();
      },
      ..._stylex.default.props(_Style.formStyle.text, _Style.formStyle.file)
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Grid2, {
      minHeight: 24,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        ..._stylex.default.props(_Style.textStyle.error),
        children: props.errorText
      })
    })]
  });
});